//fetching  the id for adding of attribute to the menu drawer container in mobile view.
let mobilemodal = document.getElementById("Details-menu-drawer-container");
// Get the modal
let modal = document.getElementById("currency-switcher-pop");

// Get the button that opens the modal
let btn = document.getElementById("myBtn");
let closeBtn = document.querySelectorAll(".close");
let changeCountryBtn = document.getElementById("changeCountryBtn");
let backBtn = document.getElementById("backBtn");
let continueBtn = document.getElementById("continueBtn");
let continueStoreBtn = document.getElementById("continueStoreBtn");
// Get both screens
let screen1 = document.getElementById("screen1");
let screen2 = document.getElementById("screen2");

document.querySelectorAll(".disclosure__button").forEach((button) => {
  button.addEventListener("click", function () {
    // Show the modal and switch to the second screen
    modal.style.display = "block";
    screen1.style.display = "none";
    screen2.style.display = "block";
    document.body.classList.add("overflow-hidden");
  });
});
// When the user clicks on <span> (x), close the modal
closeBtn.forEach((button) => {
  button.addEventListener("click", function () {
    modal.style.display = "none";
    localStorage.setItem("popupshown", true);
    document.body.classList.remove("overflow-hidden");
  });
});
// When the user clicks on the continue button, close the modal
continueStoreBtn.addEventListener("click", function () {
  modal.style.display = "none";
  document.body.classList.remove("overflow-hidden");
  localStorage.setItem("popupshown", true);
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
    document.body.classList.remove("overflow-hidden");
  }
};

// When the user clicks on Change Country button, switch screens
changeCountryBtn.onclick = function () {
  screen1.style.display = "none";
  screen2.style.display = "block";
};

// When the user clicks on Back button, switch screens
backBtn.onclick = function (event) {
  event.preventDefault();
  screen2.style.display = "none";
  screen1.style.display = "block";
};

//Continue button functionality
continueBtn.onclick = function () {
  //setting localstorage
  localStorage.setItem("popupshown", true);
  const form = this.querySelector("form");
  this.elements.input.value = event.currentTarget.dataset.value;
  if (form) form.submit();
};

document.addEventListener("DOMContentLoaded", function () {
  fetch(window.Shopify.routes.root + "browsing_context_suggestions.json")
    .then((res) => res.json())
    .then((r) => {
      // Fetching the element with the data-geo-country-wrapper attribute
      var countryWrapper = document.querySelector("[data-geo-country-wrapper]");
      // Check if the element exists
      if (countryWrapper) {
        // Replace the {{ country_name }} placeholder with the detected country name
        countryWrapper.innerHTML = countryWrapper.innerHTML.replace(
          "{{ country_name }}",
          r.detected_values.country.name
        );
        //check localstorage to display the popup
        if (
          !localStorage.getItem("popupshown") &&
          r.detected_values.country.handle.toLowerCase() !== "gb"
        ) {
          //show the popup
          setTimeout(function () {
            modal.style.display = "block";
            document.body.classList.add("overflow-hidden");
          }, 1000);
        }
      }
    })
    .catch((error) => console.error("Error fetching data:", error));

  const selectBox = document.getElementById("country-select");
  const floatingLabel = document.getElementById("floatingLabel");
  let isDropdownOpen = false;

  if (selectBox) {
    // Show the floating label when the dropdown is focused (opened)
    selectBox.addEventListener("mousedown", function () {
      floatingLabel.classList.remove("hidden");
    });

    selectBox.addEventListener("focus", function () {
      floatingLabel.classList.remove("hidden");
    });

    // Toggle the floating label when the dropdown is clicked
    selectBox.addEventListener("click", function () {
      isDropdownOpen = !isDropdownOpen;
      if (isDropdownOpen) {
        floatingLabel.classList.remove("hidden");
      } else {
        floatingLabel.classList.add("hidden");
      }
    });

    // Hide the floating label when the dropdown loses focus (closed)
    selectBox.addEventListener("blur", function () {
      isDropdownOpen = false;
      floatingLabel.classList.add("hidden");
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  let backBtn = document.getElementById("backBtn");
  let modal = document.getElementById("currency-switcher-pop");
  let mobilemodal = document.getElementById("Details-menu-drawer-container"); // Replace with the actual ID of your mobile modal
  let triggeredByDisclosureButton = false;

  document.querySelectorAll(".disclosure__button").forEach((button) => {
    button.addEventListener('click', function() {
      triggeredByDisclosureButton = true;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (window.innerWidth <= 768)) {
        modal.style.display = 'block';
      }
    });
  });

  if (backBtn) {
    backBtn.addEventListener('click', function() {
      if (triggeredByDisclosureButton) {
        modal.style.display = 'none';
        document.body.classList.remove("overflow-hidden");
        triggeredByDisclosureButton = false; // Reset the flag
      }
    });
  }

  modal.addEventListener('click', function() {
    handleModalInteraction();
  });

  modal.addEventListener('mouseover', function() {
    handleModalInteraction();
  });

  function handleModalInteraction() {
    if (triggeredByDisclosureButton) {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (window.innerWidth <= 768)) {
        mobilemodal.setAttribute("open", "");
      }
    }
  }
});